import { createContext, useContext } from "react";

export const NonceContext = createContext<string | undefined>(undefined);

export function useNonce(fallback?: string) {
  const contextNonce = useContext(NonceContext);
  const nonce = contextNonce ?? fallback;
  if (!nonce) {
    throw new Error(
      "useNonce must be used within <NonceContext.Provider> or provided fallback",
    );
  }
  return nonce;
}
